// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscribed_subscribedPage__BV9DB {
  position: relative;
  min-height: 100vh;
  height: 100vh;
  width: 100%;
  background: #0d0e11;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.subscribed_backgroundGlow__EmKTs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.subscribed_greenCornerSvg__gRsRx {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 621px;
  z-index: 0;
  pointer-events: none;
}

.subscribed_backgroundSvg__WOTiW {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 684px;
}

.subscribed_contentContainer__lzYen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 360px;
  position: relative;
  z-index: 1;
  padding-top: 80px;
}

.subscribed_iconContainer__kkHiN {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  margin-bottom: 0;
}

.subscribed_shadowWrapper__5rtDQ {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 325px;
  height: 264px;
  z-index: 0;
  pointer-events: none;
}

.subscribed_iconShadow__xMagc {
  width: 100%;
  height: 100%;
  opacity: 0.6;
}

.subscribed_smileyIcon__M-YvF {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.subscribed_smileyImage__sF23J {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.subscribed_crownImage__4kefF {
  position: absolute;
  top: -86px;
    left: 15%;
    transform: rotate(0deg);
    width: 150px;
    height: 150px;
  object-fit: contain;
  z-index: 2;
}

.subscribed_textContainer__on\\+6- {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  margin-top: 36px;
  margin-bottom: 230px;
}

.subscribed_mainHeading__d\\+LFG {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  color: #ffffff;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: pre-wrap;
}

.subscribed_mainHeading__d\\+LFG span {
  display: block;
}

.subscribed_downloadSection__9mymX {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
}

.subscribed_buttonGroup__WNhG- {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.subscribed_buttonWrapper__0Ise0 {
  width: 100%;
  display: flex;
  justify-content: center;
}

.subscribed_redirectingWrapper__KtN\\+b {
  width: 100%;
  display: flex;
  justify-content: center;
}

.subscribed_subHeading__1luYp {
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #c1c3cf;
  margin: 0;
  text-align: center;
  white-space: pre-wrap;
  padding-left: 40px;
  padding-right: 40px;
}

@media (max-width: 480px) {
  .subscribed_mainHeading__d\\+LFG {
    font-size: 28px;
    line-height: 34px;
  }
  
  .subscribed_subHeading__1luYp {
    font-size: 14px;
    line-height: 20px;
  }
  
  /* .shadowWrapper {
    width: 280px;
    height: 220px;
  }
  
  .smileyIcon {
    width: 100px;
    height: 100px;
  }
  
  .smileyImage {
    width: 70px;
    height: 70px;
  }
  
  .crownImage {
    width: 45px;
    height: 45px;
    top: -18px;
    right: -12px;
  } */
}

`, "",{"version":3,"sources":["webpack://./src/pages/Subscribed/subscribed.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;IACR,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,aAAa;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;;;;;;;;;;;;;;;;;;;KAoBG;AACL","sourcesContent":[".subscribedPage {\n  position: relative;\n  min-height: 100vh;\n  height: 100vh;\n  width: 100%;\n  background: #0d0e11;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  overflow: hidden;\n}\n\n.backgroundGlow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.greenCornerSvg {\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 621px;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.backgroundSvg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 684px;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 360px;\n  position: relative;\n  z-index: 1;\n  padding-top: 80px;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  position: relative;\n  margin-bottom: 0;\n}\n\n.shadowWrapper {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 325px;\n  height: 264px;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.iconShadow {\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n}\n\n.smileyIcon {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.smileyImage {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.crownImage {\n  position: absolute;\n  top: -86px;\n    left: 15%;\n    transform: rotate(0deg);\n    width: 150px;\n    height: 150px;\n  object-fit: contain;\n  z-index: 2;\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  margin-top: 36px;\n  margin-bottom: 230px;\n}\n\n.mainHeading {\n  font-family: 'Inter', sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: normal;\n  color: #ffffff;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  white-space: pre-wrap;\n}\n\n.mainHeading span {\n  display: block;\n}\n\n.downloadSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  width: 100%;\n}\n\n.buttonGroup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n.buttonWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.redirectingWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.subHeading {\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #c1c3cf;\n  margin: 0;\n  text-align: center;\n  white-space: pre-wrap;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n@media (max-width: 480px) {\n  .mainHeading {\n    font-size: 28px;\n    line-height: 34px;\n  }\n  \n  .subHeading {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  \n  /* .shadowWrapper {\n    width: 280px;\n    height: 220px;\n  }\n  \n  .smileyIcon {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .smileyImage {\n    width: 70px;\n    height: 70px;\n  }\n  \n  .crownImage {\n    width: 45px;\n    height: 45px;\n    top: -18px;\n    right: -12px;\n  } */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscribedPage": `subscribed_subscribedPage__BV9DB`,
	"backgroundGlow": `subscribed_backgroundGlow__EmKTs`,
	"greenCornerSvg": `subscribed_greenCornerSvg__gRsRx`,
	"backgroundSvg": `subscribed_backgroundSvg__WOTiW`,
	"contentContainer": `subscribed_contentContainer__lzYen`,
	"iconContainer": `subscribed_iconContainer__kkHiN`,
	"shadowWrapper": `subscribed_shadowWrapper__5rtDQ`,
	"iconShadow": `subscribed_iconShadow__xMagc`,
	"smileyIcon": `subscribed_smileyIcon__M-YvF`,
	"smileyImage": `subscribed_smileyImage__sF23J`,
	"crownImage": `subscribed_crownImage__4kefF`,
	"textContainer": `subscribed_textContainer__on+6-`,
	"mainHeading": `subscribed_mainHeading__d+LFG`,
	"downloadSection": `subscribed_downloadSection__9mymX`,
	"buttonGroup": `subscribed_buttonGroup__WNhG-`,
	"buttonWrapper": `subscribed_buttonWrapper__0Ise0`,
	"redirectingWrapper": `subscribed_redirectingWrapper__KtN+b`,
	"subHeading": `subscribed_subHeading__1luYp`
};
export default ___CSS_LOADER_EXPORT___;
